import { useAuthQuery } from '../apiUtils/queryHelper';
import config from '../config/config';

export interface IOrganizationIdentityModal {
	accountId: string;
	createdBy: string;
	defaultDeploymentRegion: string;
	defaultLanguage: string;
	displayName: string;
	id: string;
	mfa: { required: boolean };
	name: string;
	phoneNumber: string;
	region: string;
	type: string;
}

export const useGetOrganization = () => {
	return useAuthQuery(
		config.identity.get_organization.queryKey,
		async (axiosInstance) => {
			return axiosInstance?.get<IOrganizationIdentityModal>(
				config.identity.get_organization.url,
			);
		},
		{},
		config.identity.get_organization.scope,
	);
};

/**
 * Returns production environment checkbox visibility based on org type.
 *
 * - `showCheckbox` — whether the "Production environment" checkbox is rendered at all.
 *   Hidden for prospect orgs; visible for partners and all other org types.
 * - `showHelperText` — whether the SLA helper text is shown alongside the checkbox.
 *   Hidden for prospect and partner orgs; visible for all other org types.
 */
export const useOrgProdCheckboxState = () => {
	const { data: organizationData } = useGetOrganization();
	const orgType = organizationData?.data?.type?.toLowerCase();
	return {
		showCheckbox: orgType !== 'prospect',
		showHelperText: orgType !== 'prospect' && orgType !== 'partner',
	};
};
